var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M14.9993 10.8335C14.216 10.8335 13.491 11.1085 12.916 11.5668C12.1493 12.1752 11.666 13.1168 11.666 14.1668C11.666 14.7918 11.841 15.3835 12.1493 15.8835C12.7243 16.8502 13.7827 17.5002 14.9993 17.5002C15.841 17.5002 16.6077 17.1918 17.191 16.6668C17.4494 16.4502 17.6744 16.1835 17.8494 15.8835C18.1577 15.3835 18.3327 14.7918 18.3327 14.1668C18.3327 12.3252 16.841 10.8335 14.9993 10.8335ZM16.7244 13.8085L14.9494 15.4501C14.8327 15.5585 14.6743 15.6168 14.5243 15.6168C14.366 15.6168 14.2077 15.5585 14.0827 15.4335L13.2577 14.6085C13.016 14.3669 13.016 13.9668 13.2577 13.7251C13.4994 13.4835 13.8994 13.4835 14.141 13.7251L14.541 14.1252L15.8743 12.8918C16.1243 12.6585 16.5243 12.6752 16.7577 12.9252C16.991 13.1752 16.9744 13.5668 16.7244 13.8085Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    opacity: 0.4,
    d: "M17.5758 17.9165C17.5758 18.1498 17.3924 18.3332 17.1591 18.3332H2.84245C2.60911 18.3332 2.42578 18.1498 2.42578 17.9165C2.42578 14.4665 5.82578 11.6665 10.0008 11.6665C10.8591 11.6665 11.6925 11.7831 12.4591 12.0081C11.9675 12.5915 11.6674 13.3498 11.6674 14.1665C11.6674 14.7915 11.8424 15.3832 12.1508 15.8832C12.3174 16.1665 12.5341 16.4248 12.7841 16.6415C13.3674 17.1748 14.1424 17.4998 15.0008 17.4998C15.9341 17.4998 16.7758 17.1165 17.3758 16.4998C17.5091 16.9498 17.5758 17.4248 17.5758 17.9165Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M10.0007 9.99984C12.3018 9.99984 14.1673 8.13436 14.1673 5.83317C14.1673 3.53198 12.3018 1.6665 10.0007 1.6665C7.69946 1.6665 5.83398 3.53198 5.83398 5.83317C5.83398 8.13436 7.69946 9.99984 10.0007 9.99984Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTick);
export default __webpack_public_path__ + "static/media/user-tick.bfb055f70149e3b6515b08b0ab0c20cc.svg";
export { ForwardRef as ReactComponent };